import React from "react";
import { AlertTriangle } from "lucide-react";

export interface LaunchDateBannerProps {
  onEditDate: () => void;
}

const LaunchDateBanner = ({ onEditDate }: LaunchDateBannerProps) => (
  <div className="flex items-start gap-3 rounded-[10px] border border-solid border-[#fee685] bg-[#fffbeb] px-4 py-3 dark:border-[#973c00] dark:bg-[#461901]">
    <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[#7b3306] dark:text-[#fef3c6]" />
    <div className="flex flex-col gap-1 text-sm leading-5">
      <span className="font-medium text-[#7b3306] dark:text-[#fef3c6]">Please, update date</span>
      <span className="text-[#973c00] dark:text-[#fef3c6]">
        Your campaign launch must be scheduled at least 5 business days from today. Please select a new launch date.
      </span>
      <button
        type="button"
        data-cy="launchDateBannerEditButton"
        onClick={onEditDate}
        className="self-start bg-transparent p-0 text-left text-[#973c00] underline dark:text-[#fef3c6]"
      >
        Edit launch date
      </button>
    </div>
  </div>
);

export { LaunchDateBanner };
